import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  DateRangeParams,
  ResellerUsageResponse
} from '@utils/types/resellers/dashboard.ts';

export const useGetResellerUsage = (dateRange?: DateRangeParams) => {
  const fetchResellerUsage = async () => {
    const endpoint = GET_URL(
      dateRange?.periodStart || '',
      dateRange?.periodEnd || ''
    ).resellerUsage;

    if (!endpoint) {
      throw new Error('Reseller usage endpoint not configured');
    }

    const { data } = await Axios.get<ResellerUsageResponse>(endpoint);
    return data;
  };

  return useQuery<ResellerUsageResponse, AxiosError<BaseError>>(
    ['resellerUsage', dateRange?.periodStart, dateRange?.periodEnd],
    fetchResellerUsage,
    {
      keepPreviousData: true, // Keep showing old data while fetching new
      retry: false,
      staleTime: 0, // Always fetch fresh data when query key changes
      refetchOnMount: false,
      enabled: true // Always enabled, will refetch when query key changes
    }
  );
};
